import script from "./Incidents.vue?vue&type=script&setup=true&lang=js"
export * from "./Incidents.vue?vue&type=script&setup=true&lang=js"

import "./Incidents.vue?vue&type=style&index=0&id=5afd1db2&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afd1db2"]])

export default __exports__